import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb.component';
import MetaComp from '../../components/meta-comp/MetaComp.component';
import ProgressBar from '../../components/progress-bar/ProgressBar.component';
import AvailableEventsContainer from '../../containers/available-events/AvailableEvents.container';
import EventDashboardContainer from '../../containers/event-dashboard/EventDashboard.container';
import { saveClientData } from '../../redux/actions/clientData.actions';
import { appError, appErrorClear } from '../../redux/actions/error.action';
import { logout } from '../../redux/actions/user.actions';
import { getApiUrl } from '../../utils/apiUrls';
import instance from '../../utils/axios';
import ErrorController from '../error/ErrorController.page';

const Homepage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const chkError = useSelector((state) => state.error);
    const appSettings = useSelector(state => state.appSettings);
    const [eventData, setEventData] = React.useState(null);
    const [searchParams] = useSearchParams();
    const getRefId = searchParams.get('refId');

    const breadcrumbData = [
        {
            iconClass: regular("house"),
            link: '/'
        },
        {
            label: t("dashboard"),
        }
    ]

    const fetchEvents = async() => {
        try {
            const token = localStorage.getItem('token');
            if(!!token) {
                const events = await instance.get(`${getApiUrl('getDashboard')}`, {
                    headers: {
                        "Authorization" : `Bearer ${token}`,
                    }
                });
                if(!!events.data) {
                    setEventData(events.data);
                    dispatch(saveClientData({ logo: events.data?.logoUrl }))

                    if(events.data?.refId) navigate(`?refId=${events.data?.refId}`);
                    
                    if(chkError.location === 'home') appErrorClear(dispatch);
                }
            } else {
                dispatch(logout(appSettings.lang, getRefId));
            }
        } catch (error) {
            appError('home', error, dispatch);
        }
    }

    React.useEffect(() => {
        fetchEvents();
        // eslint-disable-next-line
    }, [])

    const handleError = () => chkError.location === 'task-list' || chkError.location === 'home'

    return(
        handleError() ? <ErrorController data={chkError} /> : <div className='cm-homepage-container cm-cand-page-container'>
            <Breadcrumb data={breadcrumbData}/>
            {eventData !== null ?
            <>
                <EventDashboardContainer t={t} data={eventData} refId={getRefId} />
                <AvailableEventsContainer t={t} data={eventData.candidateEventList} totalEvents={!!eventData?.totalEventsCount ? eventData?.totalEventsCount : 0 } />
            </>
            : <ProgressBar />
            }
            <MetaComp title={t("home_page_title")} />
            <Outlet />
        </div>
    )

}

export default Homepage;